import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6483c5ac"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6483c5ac')) {
      api.createRecord('6483c5ac', component.options)
    } else {
      api.reload('6483c5ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6483c5ac", function () {
      api.rerender('6483c5ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipClassroom/directToEvaluationsClass/index.vue"
export default component.exports